export default "__VITE_ASSET__D08CUqNA__";